import request from 'utils/request'
import { LENGJ_HEADERS } from '@/config/lengj-index'

// 企业新闻舆情接口
export const getEnterpriseNewsInfo = data =>
  request().post('riskraider/v3.1/newsInfo/getEnterpriseNewsInfo', data, {
    headers: LENGJ_HEADERS,
  })
